import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { MotionPlugin } from '@vueuse/motion';
import VueTheMask from 'vue-the-mask'
import Vue3Toastify from "vue3-toastify";
import swipeBack from './directives/swipeBack';
import vTooltip from './directives/vTooltip';
import { applyBranding } from './utils/branding'

import "vue3-toastify/dist/index.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

applyBranding()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(MotionPlugin)
app.use(Vue3Toastify, {
    "theme": "dark",
    "autoClose": 3500,
    "hideProgressBar": true,
    "transition": "slide",
    "position": 'bottom-center',
    "dangerouslyHTMLString": true,
})
app.use(VueTheMask)

app.directive('swipe-back', swipeBack);
app.directive('tooltip', vTooltip);

const authStore = useAuthStore()
authStore.initializeAuth().finally(() => {
    app.mount('#app')
})
